import { TYPES } from "src/ipm-shared/components/PaymentTypes/const";
import { BRAND } from "src/ipm-shared/Utils/Images";

export enum PURPOSE {
  RENTAL = 1,
  SALARY,
  INVOICE,
  COLLECTION,
  SELF_TRANSFER,
  PARTNERSHIP,
  SALARY_BUSINESS,
  INSURANCE
}

export const ADD_FORM = "add_payment_form";
export const SEARCH_FORM = "admin_payment_search_form";
export const SEARCH_CDD_FORM = "admin_cdd_search_form";
export const REFUND_FORM = "refund_form";
export const EXPEDITE_FORM = "expedite_form";
export const CONFIRM_FORM = "confirm_form";
export const PAYMENT_CHECK_SEARCH_FORM = "payment_check_search_form";
export const PAYMENT_PAYEE_EDIT_FORM = "payment_payee_edit_form";
export const PAYOUT_REQUEST_SEARCH_FORM = "admin_payout_request_search_form";
export const CREATE_PAYOUT_FORM = "admin_create_payout_form";
export const PAYMENT_DETAIL_FORM = "admin_payment_detail_form";
export const PAYMENT_BULK_UPLOAD_FILE_FORM = "payment_bulk_upload_file_form";
export const ADMIN_REQUOTE_WALLEX_PAYMENT_FORM =
  "admin_requote_wallex_payment_form";

// Scheduled
export const SCHEDULE_EDIT_FORM = "schedule_edit_form";
export const SCHEDULE_EDIT_COUPON_FORM = "schedule_edit_coupon_form";
export const BULK_REQUEST_FORM = "bulk_request_form";
export const HISTORY_APPROVAL_SEARCH_FORM = "history_approval_search_form";

export enum PAYMENT_STATUS {
  DRAFT = 1,
  IN_PROGRESS, // Is schedule
  IN_PROGRESS_2,
  COMPLETED,
  DECLINED,
  CANCELLED_DUE_TO_DELETED_CARD,
  CANCELLED_DUE_TO_DELETED_SCHEDULE,
  CANCELLED_DUE_TO_DELETED_PROPERTY,
  FULLY_REFUNDED_WITH_FEE,
  FULLY_REFUNDED_WITHOUT_FEE,
  ON_HOLD,
  REQUEST,
  INT_PENDING = 15,
  PAID,
  UNDER_REVIEW = 17,
  ON_SCREENING_FOR_COMPLY_ADVANTAGE = 19,
  HOLD_FOR_COMPLY_ADVANTAGE = 21,
  SHORT,
  CRYPTO_HOLD,
  CRYPTO_PAYMENT_REFUND_REQUESTED,
  BLOCKED = 26,
  REFUND_PENDING = 27,
  ESCALATED = 28
}

export const REFUND_TYPE = {
  PARTIAL_REFUND_FEE: "partial_refund_fee",
  PARTIAL_REFUND_PRINCIPAL: "partial_refund_principal",
  REFUND_WITHOUT_FEE: "refund_without_fee",
  REFUND_WITH_FEE: "refund_with_fee",
  FULL_REFUND: "full_refund",
  PARTIAL_REFUND_PRINCIPAL_WITH_FEES: "partial_refund_principal_with_fees"
};

export const PAGE_COUNT = 50;
export const ADMIN_PAGE_COUNT = 200;
export const SCHEDULED_PAGE_COUNT = 50;

export const PAYMENT_MODEL = {
  BUYER_FUNDED: "buyer_funded",
  SUPPLIER_FUNDED: "supplier_funded"
};

export enum PAYOUT_PARTY {
  WALLEX = 1,
  MASTERCARD_MOVE
}
export const BULK_REQUEST_PAYMENT_OPTIONS = {
  BULK_UPLOAD_FILE: "bulk_upload_file",
  UPDATE_BANK_ACCOUNT: "update_bank_account",
  UPDATE_PAYMENT_DESCRIPTION: "update_payment_description",
  UPDATE_PAYOUT_DATE: "update_payout_date",
  CANCELLED_SCHEDULED_PAYMENTS: "cancel_scheduled_payments"
};

export const SCHEDULE_STATUS = {
  ACTIVE: "y",
  INACTIVE: "n"
};

export const SCHEDULE_FREQUENCY = {
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  BIWEEKLY: "biweekly",
  QUARTERLY: "quarterly",
  BIANNALLY: "biannually"
};

export const REFUND_REQUEST_ACTION_TYPES = {
  EDIT_PAYMENT_PAYEE: "edit_payment_payee",
  BULK_UPLOAD_PAYMENT_FILE: "bulk_upload_payment_file",
  CHANGE_STATUS: "change_status_payment",
  REINITIATE_WALLEX_PAYMENT: "reinitiate_wallex"
};

export const SETTLEMENT_CURRENCY = {
  SETTLE_IN_SGD: "settle_in_sgd",
  SETTLE_IN_BUY_CURRENCY: "settle_in_buy_currency"
};

export const SUPPLIER_PAYOUT_TYPES = {
  UEN: "uen",
  BANK_ACCOUNT: "bank_account"
};

export const BULK_REQUEST_ACTION_TYPES = {
  UPDATE_INSTANT_PAY_LIMIT: "update_instant_pay_limit",
  ADD_BANK_ACCOUNT: "add_bank_account"
};

export const REQUEST_PROCESS_OPTION = [
  {
    label: "Approve",
    value: "approve"
  },
  {
    label: "Reject",
    value: "reject"
  }
];

export const TYPE_VIEW_HISTORY_APPROVAL = {
  PAYMENT: "payment",
  SCHEDULE: "schedule",
  BULK_REQUEST: "bulk_request"
};

export const ALLOWED_INT_STATUSES = [
  PAYMENT_STATUS.DRAFT,
  PAYMENT_STATUS.COMPLETED,
  PAYMENT_STATUS.IN_PROGRESS_2,
  PAYMENT_STATUS.INT_PENDING,
  PAYMENT_STATUS.FULLY_REFUNDED_WITH_FEE,
  PAYMENT_STATUS.FULLY_REFUNDED_WITHOUT_FEE,
  PAYMENT_STATUS.REFUND_PENDING,
  PAYMENT_STATUS.ON_HOLD,
  PAYMENT_STATUS.HOLD_FOR_COMPLY_ADVANTAGE,
  PAYMENT_STATUS.ON_SCREENING_FOR_COMPLY_ADVANTAGE
];

export const ALLOWED_INT_PURPOSES = [TYPES.RENTAL, TYPES.INVOICE];

export const ALLOWED_INT_CARD_BRANDS = [
  BRAND.VISA,
  BRAND.MASTER_CARD,
  BRAND.UNION_PAY
];

export const NOT_ALLOWED_NORMAL_PURPOSES = [
  PAYMENT_STATUS.INT_PENDING,
  PAYMENT_STATUS.PAID
];
